<template>
    <v-container class="alert">
        <v-alert
            :value="showAlert"
            outlined
            transition="scale-transition"
            :type="type"
        >
            {{ message }}
        </v-alert>
    </v-container>
</template>

<script>
    export default {
        props: {
            showAlert:
                {
                    type: Boolean,
                    default: false
                },
            message:
                {
                    type: String,
                    default: ''
                },
            type:
                {
                    type: String,
                    default: 'error'
                }
        },
        data() {
            return {
            }
        },
        watch: {
        },
        created() {
        },
        methods: {
        }
    }
</script>
<style scoped>
.alert {
    display: flex;
    justify-content: center;
}

</style>
<style>
.v-icon {
    align-self: center !important;
}
</style>
